export default {
    menus() {
        return [
            {
                cn: '首页',
                pages: [
                    { cn: '欢迎使用后台系统', en: 'Welcome', path: 'home' },
                ]
            }, {
                cn: '信息管理',
                pages: [
                    { cn: '通知公告', en: '', path: 'notices' },
                    { hidden: true, cn: '通知公告详情', en: '', path: 'notice' },
                ]
            }, {
                cn: '查专业',
                pages: [
                    { cn: '专科', en: '', path: 'czy_zk' },
                    { cn: '本科', en: '', path: 'czy_bk' },
                    { cn: '职业本科', en: '', path: 'czy_zybk' },
                    { cn: '硕士研究生', en: '', path: 'czy_ssyjs' },
                ]
            }, {
                cn: '查岗位',
                pages: [
                    { cn: '查岗位专业目录', en: '', path: 'cgw_zyml' },
                    { cn: '专科', en: '', path: 'cgw_zk' },
                    { cn: '本科及以上 省考', en: '', path: 'cgw_bk_sk' },
                    { cn: '本科及以上 国考', en: '', path: 'cgw_bk_gk' },
                ]
            }, {
                cn: '查单位',
                pages: [
                    { cn: '查单位', en: '', path: 'cdw' },
                ]
            }, {
                cn: '查进面分数',
                pages: [
                    { cn: '国考', en: '', path: 'cjmfs_gk' },
                    { cn: '省考', en: '', path: 'cjmfs_sk' },
                ]
            }, {
                cn: '选调生资质',
                pages: [
                    { cn: '中央选调生', en: '', path: 'zyxds' },
                    { cn: '定向选调生', en: '', path: 'dxxds' },
                    { cn: '普通选调生', en: '', path: 'ptxds' },
                ]
            }, {
                cn: '选调生资讯',
                pages: [
                    { cn: '中央选调生', en: '', path: 'zyxds_notices' },
                    { hidden: true, cn: '中央选调生', en: '', path: 'zyxds_notice' },
                    { cn: '定向选调生', en: '', path: 'dxxds_notices' },
                    { hidden: true, cn: '定向选调生', en: '', path: 'dxxds_notice' },
                    { cn: '普通选调生', en: '', path: 'ptxds_notices' },
                    { hidden: true, cn: '普通选调生', en: '', path: 'ptxds_notice' },
                ]
            }, {
                cn: '通用规则数据',
                pages: [
                    { cn: '高校名单', en: '', path: 'report2Gxmd' },
                    { cn: '选调机会名单', en: '', path: 'reportXdjh' },
                ]
            }, {
                cn: '初级报告规则',
                pages: [
                    { cn: '生成过程提示语', en: '', path: 'report2Config' },
                    { cn: '专业目录', en: '', path: 'report2Zyml' },
                    { cn: '校徽', en: '', path: 'report2Xh' },
                    { cn: '院校立体认知', en: '', path: 'report2Yxltrz' },
                    { cn: '专业立体认知', en: '', path: 'report2Zyltrz' },
                    { cn: '本科可报考岗位', en: '', path: 'report2Bkkbkgw' },
                    { cn: '专科优势专业', en: '', path: 'report2Zkyszy' },
                ]
            }, {
                cn: '高阶报告规则',
                pages: [
                    { cn: '生成过程提示语', en: '', path: 'reportConfig' },
                    { cn: '规划报告AI设置', en: '', path: 'reportAi' },
                    { cn: '专业目录', en: '', path: 'reportZyml' },
                    { cn: '国考职位表', en: '', path: 'reportGkzw' },
                    { cn: '省考职位表', en: '', path: 'reportSkzw' },
                    { cn: '军队文职职位表', en: '', path: 'reportJdwzzw' },
                    { cn: '优势院校、机会名单', en: '', path: 'reportYsjh' },
                ]
            }, {
                cn: '客户信息',
                pages: [
                    { cn: '客户管理', en: '', path: 'accountList' },
                    { hidden: true, cn: '客户详情', en: '', path: 'accountDetail' },
                    { cn: '初级报告', en: '', path: 'report2List' },
                    { hidden: true, cn: '初级报告详情', en: '', path: 'report2Detail' },
                    { cn: '高阶报告', en: '', path: 'reportList' },
                    { hidden: true, cn: '高阶报告详情', en: '', path: 'reportDetail' },
                    { cn: '客户设置', en: '', path: 'accountSetting' },
                ]
            }, {
                cn: '系统设置',
                pages: [
                    { cn: '平台设置', en: '', path: 'systems' },
                    { hidden: true, cn: '平台设置详情', en: '', path: 'system' },
                    { cn: '素材中心', en: '', path: 'moments' },
                    { hidden: true, cn: '素材详情', en: '', path: 'moment' },
                    { cn: '页面设置', en: '', path: 'promotion' },
                    { cn: '客服设置', en: '', path: 'kf' },
                    { cn: '用户协议', en: '', path: 'agreement' },
                    { cn: '隐私政策', en: '', path: 'privacy' },
                ]
            }, {
                cn: '后台设置',
                pages: [
                    { cn: '个人中心', en: 'My', path: 'my' },
                    { cn: '权限管理', en: 'Role', path: 'roleList' },
                    { hidden: true, cn: '权限详情', en: 'Role Detail', path: 'roleDetail' },
                    { cn: '后台用户', en: 'Staff', path: 'userList' },
                    { hidden: true, cn: '后台用户详情', en: 'Staff Detail', path: 'userDetail' },
                ]
            }
        ]
    },
    filter(hidden, paths) {
        const menus = this.menus()
        for (let menuIndex = menus.length - 1; menuIndex >= 0; menuIndex--) {
            const menu = menus[menuIndex]
            if (menu != null && menu.pages != null) {
                for (let pageIndex = menu.pages.length - 1; pageIndex >= 0; pageIndex--) {
                    let splice = false
                    const page = menu.pages[pageIndex]
                    if (hidden === true && !page.hidden) {
                        splice = true
                    }
                    if (hidden === false && page.hidden) {
                        splice = true
                    }
                    if (paths != null && paths.length > 0 && !paths.includes(page.path)) {
                        splice = true
                    }
                    if (splice) {
                        menu.pages.splice(pageIndex, 1)
                    }
                }
            }
            if (menu == null || menu.pages == null || menu.pages.length == 0) {
                menus.splice(menuIndex, 1)
            }
        }
        return menus
    }
}